import { atom } from 'jotai';
import { VisualOnStream } from './types';

export const playerWaitingAtom = atom(false);

export const playerOpenedAtom = atom(false);

export const openPlayerDevicesAtom = atom(false);

export const visualOnStreamAtom = atom<VisualOnStream | undefined>(undefined);

export const descalePlayerAtom = atom<boolean>(false);

export const openChannelsAtom = atom(false);

// Set while the user interacts with the channel list, so the controls auto-hide stays paused.
export const channelsInteractionAtom = atom(false);
